var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C11.7677 20 11.5405 19.923 11.3603 19.7831L9.46326 18.3105C8.07767 17.2349 6.93979 15.8528 6.17265 14.3136C5.40551 12.7745 5 11.06 5 9.35564V6.91043C5 6.61463 5.25346 6.3631 5.56306 6.34745C7.67428 6.24092 9.71536 5.49392 11.3603 4.21698C11.5405 4.07708 11.7677 4 12 4C12.2323 4 12.4595 4.07704 12.6397 4.21694C14.2847 5.49392 16.3258 6.24092 18.437 6.34745C18.7466 6.36306 19 6.61455 19 6.91032V9.35544C19 11.0598 18.5945 12.7743 17.8274 14.3135C17.0602 15.8527 15.9223 17.2348 14.5367 18.3104L12.6397 19.783C12.4595 19.923 12.2323 20 12 20Z",
    stroke: "#878787",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield2);
export default __webpack_public_path__ + "static/media/shield-2.f97c17ff5ff6cf2e07dbb7a6381b6829.svg";
export { ForwardRef as ReactComponent };